import { createSlice } from '@reduxjs/toolkit';
import { createReducerNames } from '../../../core/helpers/default';

const name = 'donateFormsList';

const reducersKeys = {
  getDonateFormsRequest: 'getDonateFormsRequest',
  getDonateFormsSuccess: 'getDonateFormsSuccess',
  getDonateFormsFailure: 'getDonateFormsFailure',
  deleteDonateFormRequest: 'deleteDonateFormRequest',
  deleteDonateFormSuccess: 'deleteDonateFormSuccess',
  deleteDonateFormFailure: 'deleteDonateFormFailure',
};

const initialState = {
  forms: [],
  meta: {
    page: 1,
    lastPage: 1,
    perPage: 10,
  },
  loaded: false,
  loading: false,
  error: null,
};

const donateFormsList = createSlice({
  name,
  initialState,
  reducers: {
    [reducersKeys.getDonateFormsRequest]: (state) => {
      state.loading = true;
      state.loaded = false;
    },
    [reducersKeys.getDonateFormsSuccess]: (state, { payload }) => {
      state.forms = payload.forms;
      state.meta = { ...payload.meta };
      state.loading = false;
      state.loaded = true;
    },
    [reducersKeys.getDonateFormsFailure]: (state, { payload }) => {
      state.loading = false;
      state.loaded = true;
      state.error = payload.error;
    },
    [reducersKeys.deleteDonateFormRequest]: (state) => {
      state.loading = true;
    },
    [reducersKeys.deleteDonateFormSuccess]: (state, { payload }) => {
      state.forms = state.forms.filter((t) => (t.id !== payload.deletedId));
      state.loading = false;
    },
    [reducersKeys.deleteDonateFormFailure]: (state) => {
      state.loading = false;
    },
  },
});

export const donateFormsListReducers = createReducerNames(name, reducersKeys);
export const { actions } = donateFormsList;

export default donateFormsList.reducer;
